<!-- sidebar header start here -->
<div class="sidebar-header">
  <div class="header-row">
    <div class="d-flex gap-2 align-items-center">
      <a [routerLink]="redirectRoute" [queryParams]="redirectQueryParams"
        ><svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.75 16.25H18.75C19.1042 16.25 19.401 16.1302 19.6406 15.8906C19.8802 15.651 20 15.3542 20 15C20 14.6458 19.8802 14.349 19.6406 14.1094C19.401 13.8698 19.1042 13.75 18.75 13.75H14.75L15.875 12.625C16.1042 12.3958 16.2188 12.1042 16.2188 11.75C16.2188 11.3958 16.1042 11.1042 15.875 10.875C15.6458 10.6458 15.3542 10.5312 15 10.5312C14.6458 10.5312 14.3542 10.6458 14.125 10.875L10.875 14.125C10.625 14.375 10.5 14.6667 10.5 15C10.5 15.3333 10.625 15.625 10.875 15.875L14.125 19.125C14.3542 19.3542 14.6458 19.4688 15 19.4688C15.3542 19.4688 15.6458 19.3542 15.875 19.125C16.1042 18.8958 16.2188 18.6042 16.2188 18.25C16.2188 17.8958 16.1042 17.6042 15.875 17.375L14.75 16.25ZM15 27.5C13.2708 27.5 11.6458 27.1719 10.125 26.5156C8.60417 25.8594 7.28125 24.9688 6.15625 23.8438C5.03125 22.7188 4.14062 21.3958 3.48438 19.875C2.82812 18.3542 2.5 16.7292 2.5 15C2.5 13.2708 2.82812 11.6458 3.48438 10.125C4.14062 8.60417 5.03125 7.28125 6.15625 6.15625C7.28125 5.03125 8.60417 4.14062 10.125 3.48438C11.6458 2.82812 13.2708 2.5 15 2.5C16.7292 2.5 18.3542 2.82812 19.875 3.48438C21.3958 4.14062 22.7188 5.03125 23.8438 6.15625C24.9688 7.28125 25.8594 8.60417 26.5156 10.125C27.1719 11.6458 27.5 13.2708 27.5 15C27.5 16.7292 27.1719 18.3542 26.5156 19.875C25.8594 21.3958 24.9688 22.7188 23.8438 23.8438C22.7188 24.9688 21.3958 25.8594 19.875 26.5156C18.3542 27.1719 16.7292 27.5 15 27.5Z"
            fill="#004B64"
          />
        </svg>
      </a>
      <h4 class="order-number">{{ orderData?.orderNumber }}</h4>
    </div>
    <!-- <div class="dropdown">
      <button
        class="btn-icon"
        type="button"
        id="orderDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="More options"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 25C14.3125 25 13.724 24.7552 13.2344 24.2656C12.7448 23.776 12.5 23.1875 12.5 22.5C12.5 21.8125 12.7448 21.224 13.2344 20.7344C13.724 20.2448 14.3125 20 15 20C15.6875 20 16.276 20.2448 16.7656 20.7344C17.2552 21.224 17.5 21.8125 17.5 22.5C17.5 23.1875 17.2552 23.776 16.7656 24.2656C16.276 24.7552 15.6875 25 15 25ZM15 17.5C14.3125 17.5 13.724 17.2552 13.2344 16.7656C12.7448 16.276 12.5 15.6875 12.5 15C12.5 14.3125 12.7448 13.724 13.2344 13.2344C13.724 12.7448 14.3125 12.5 15 12.5C15.6875 12.5 16.276 12.7448 16.7656 13.2344C17.2552 13.724 17.5 14.3125 17.5 15C17.5 15.6875 17.2552 16.276 16.7656 16.7656C16.276 17.2552 15.6875 17.5 15 17.5ZM15 10C14.3125 10 13.724 9.75521 13.2344 9.26562C12.7448 8.77604 12.5 8.1875 12.5 7.5C12.5 6.8125 12.7448 6.22396 13.2344 5.73438C13.724 5.24479 14.3125 5 15 5C15.6875 5 16.276 5.24479 16.7656 5.73438C17.2552 6.22396 17.5 6.8125 17.5 7.5C17.5 8.1875 17.2552 8.77604 16.7656 9.26562C16.276 9.75521 15.6875 10 15 10Z"
            fill="#5B5453"
          />
        </svg>
      </button>
      <ul
        class="dropdown-menu dropdown-menu-end"
        aria-labelledby="orderDropdown"
      >
        <li>
          <a class="dropdown-item" href="#">
            <span>Cancel order</span>
          </a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item text-danger" href="#">
            <span>Delete Order</span>
          </a>
        </li>
      </ul>
    </div> -->
  </div>
</div>
<!-- sidebar header end here -->
<bst-frontend-customer-details [orderBy]="orderData?.orderBy">
</bst-frontend-customer-details>
<bst-frontend-order-details [orderDetails]="orderDetails">
</bst-frontend-order-details>
<bst-frontend-fare-details
  *ngIf="
    !showFareDetails.includes(orderData?.state?.code) ||
    oderType.includes(orderData?.type)
  "
  [orderDetails]="orderDetails"
></bst-frontend-fare-details>
<!-- order invoice start -->
<div
  class="verified-card"
  *ngIf="showInvoiceDownload.includes(orderData?.state?.code)"
>
  <div class="verified-content">
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 26V3.25C3.75 3.10417 3.8125 3.00521 3.9375 2.95312C4.0625 2.90104 4.17708 2.92708 4.28125 3.03125L5.1875 3.9375C5.3125 4.0625 5.45833 4.125 5.625 4.125C5.79167 4.125 5.9375 4.0625 6.0625 3.9375L7.0625 2.9375C7.1875 2.8125 7.33333 2.75 7.5 2.75C7.66667 2.75 7.8125 2.8125 7.9375 2.9375L8.9375 3.9375C9.0625 4.0625 9.20833 4.125 9.375 4.125C9.54167 4.125 9.6875 4.0625 9.8125 3.9375L10.8125 2.9375C10.9375 2.8125 11.0833 2.75 11.25 2.75C11.4167 2.75 11.5625 2.8125 11.6875 2.9375L12.6875 3.9375C12.8125 4.0625 12.9583 4.125 13.125 4.125C13.2917 4.125 13.4375 4.0625 13.5625 3.9375L14.5625 2.9375C14.6875 2.8125 14.8333 2.75 15 2.75C15.1667 2.75 15.3125 2.8125 15.4375 2.9375L16.4375 3.9375C16.5625 4.0625 16.7083 4.125 16.875 4.125C17.0417 4.125 17.1875 4.0625 17.3125 3.9375L18.3125 2.9375C18.4375 2.8125 18.5833 2.75 18.75 2.75C18.9167 2.75 19.0625 2.8125 19.1875 2.9375L20.1875 3.9375C20.3125 4.0625 20.4583 4.125 20.625 4.125C20.7917 4.125 20.9375 4.0625 21.0625 3.9375L22.0625 2.9375C22.1875 2.8125 22.3333 2.75 22.5 2.75C22.6667 2.75 22.8125 2.8125 22.9375 2.9375L23.9375 3.9375C24.0625 4.0625 24.2083 4.125 24.375 4.125C24.5417 4.125 24.6875 4.0625 24.8125 3.9375L25.7188 3.03125C25.8229 2.92708 25.9375 2.90104 26.0625 2.95312C26.1875 3.00521 26.25 3.10417 26.25 3.25V26C26.25 26.2917 26.125 26.4896 25.875 26.5938C25.625 26.6979 25.3958 26.6458 25.1875 26.4375L24.8125 26.0625C24.6875 25.9375 24.5417 25.875 24.375 25.875C24.2083 25.875 24.0625 25.9375 23.9375 26.0625L22.9375 27.0625C22.8125 27.1875 22.6667 27.25 22.5 27.25C22.3333 27.25 22.1875 27.1875 22.0625 27.0625L21.0625 26.0625C20.9375 25.9375 20.7917 25.875 20.625 25.875C20.4583 25.875 20.3125 25.9375 20.1875 26.0625L19.1875 27.0625C19.0625 27.1875 18.9167 27.25 18.75 27.25C18.5833 27.25 18.4375 27.1875 18.3125 27.0625L17.3125 26.0625C17.1875 25.9375 17.0417 25.875 16.875 25.875C16.7083 25.875 16.5625 25.9375 16.4375 26.0625L15.4375 27.0625C15.3125 27.1875 15.1667 27.25 15 27.25C14.8333 27.25 14.6875 27.1875 14.5625 27.0625L13.5625 26.0625C13.4375 25.9375 13.2917 25.875 13.125 25.875C12.9583 25.875 12.8125 25.9375 12.6875 26.0625L11.6875 27.0625C11.5625 27.1875 11.4167 27.25 11.25 27.25C11.0833 27.25 10.9375 27.1875 10.8125 27.0625L9.8125 26.0625C9.6875 25.9375 9.54167 25.875 9.375 25.875C9.20833 25.875 9.0625 25.9375 8.9375 26.0625L7.9375 27.0625C7.8125 27.1875 7.66667 27.25 7.5 27.25C7.33333 27.25 7.1875 27.1875 7.0625 27.0625L6.0625 26.0625C5.9375 25.9375 5.79167 25.875 5.625 25.875C5.45833 25.875 5.3125 25.9375 5.1875 26.0625L4.8125 26.4375C4.60417 26.6458 4.375 26.6979 4.125 26.5938C3.875 26.4896 3.75 26.2917 3.75 26ZM8.75 21.25H21.25C21.6042 21.25 21.901 21.1302 22.1406 20.8906C22.3802 20.651 22.5 20.3542 22.5 20C22.5 19.6458 22.3802 19.349 22.1406 19.1094C21.901 18.8698 21.6042 18.75 21.25 18.75H8.75C8.39583 18.75 8.09896 18.8698 7.85938 19.1094C7.61979 19.349 7.5 19.6458 7.5 20C7.5 20.3542 7.61979 20.651 7.85938 20.8906C8.09896 21.1302 8.39583 21.25 8.75 21.25ZM8.75 16.25H21.25C21.6042 16.25 21.901 16.1302 22.1406 15.8906C22.3802 15.651 22.5 15.3542 22.5 15C22.5 14.6458 22.3802 14.349 22.1406 14.1094C21.901 13.8698 21.6042 13.75 21.25 13.75H8.75C8.39583 13.75 8.09896 13.8698 7.85938 14.1094C7.61979 14.349 7.5 14.6458 7.5 15C7.5 15.3542 7.61979 15.651 7.85938 15.8906C8.09896 16.1302 8.39583 16.25 8.75 16.25ZM8.75 11.25H21.25C21.6042 11.25 21.901 11.1302 22.1406 10.8906C22.3802 10.651 22.5 10.3542 22.5 10C22.5 9.64583 22.3802 9.34896 22.1406 9.10938C21.901 8.86979 21.6042 8.75 21.25 8.75H8.75C8.39583 8.75 8.09896 8.86979 7.85938 9.10938C7.61979 9.34896 7.5 9.64583 7.5 10C7.5 10.3542 7.61979 10.651 7.85938 10.8906C8.09896 11.1302 8.39583 11.25 8.75 11.25Z"
        fill="#17B26A"
      />
    </svg>

    <div class="verified-details">
      <p class="verified-text">
        {{ orderData?.invoiceDetail?.invoiceFile?.name }}
      </p>
      <p class="gstin-text">
        {{
          this._commonService.getStatusDate(
            this.orderDetails?.historyCompact,
            'Payment Pending'
          ) | date : 'HH:mm ddMMM yyyy'
        }}
      </p>
    </div>
    <button
      class="btn-copy-gstin"
      aria-label="Copy GSTIN"
      (click)="onDownloadPdf()"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16536 16.667H15.832C16.0681 16.667 16.2661 16.7469 16.4258 16.9066C16.5855 17.0663 16.6654 17.2642 16.6654 17.5003C16.6654 17.7364 16.5855 17.9344 16.4258 18.0941C16.2661 18.2538 16.0681 18.3337 15.832 18.3337H4.16536C3.92925 18.3337 3.73134 18.2538 3.57161 18.0941C3.41189 17.9344 3.33203 17.7364 3.33203 17.5003C3.33203 17.2642 3.41189 17.0663 3.57161 16.9066C3.73134 16.7469 3.92925 16.667 4.16536 16.667ZM9.9987 14.4795C9.8737 14.4795 9.75217 14.4517 9.63411 14.3962C9.51606 14.3406 9.41536 14.2573 9.33203 14.1462L5.20703 8.85449C4.9987 8.57671 4.97092 8.28158 5.1237 7.96908C5.27648 7.65658 5.52648 7.50033 5.8737 7.50033H7.4987V2.50033C7.4987 2.26421 7.57856 2.0663 7.73828 1.90658C7.898 1.74685 8.09592 1.66699 8.33203 1.66699H11.6654C11.9015 1.66699 12.0994 1.74685 12.2591 1.90658C12.4188 2.0663 12.4987 2.26421 12.4987 2.50033V7.50033H14.1237C14.4709 7.50033 14.7209 7.65658 14.8737 7.96908C15.0265 8.28158 14.9987 8.57671 14.7904 8.85449L10.6654 14.1462C10.582 14.2573 10.4813 14.3406 10.3633 14.3962C10.2452 14.4517 10.1237 14.4795 9.9987 14.4795Z"
          fill="#17B26A"
        />
      </svg>
    </button>
    <!-- <button class="btn-copy-gstin" aria-label="Copy GSTIN">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.168 18.3337C13.4735 18.3337 12.8832 18.0906 12.3971 17.6045C11.911 17.1184 11.668 16.5281 11.668 15.8337C11.668 15.7503 11.6888 15.5559 11.7305 15.2503L5.8763 11.8337C5.65408 12.042 5.39714 12.2052 5.10547 12.3232C4.8138 12.4413 4.5013 12.5003 4.16797 12.5003C3.47352 12.5003 2.88325 12.2573 2.39714 11.7712C1.91102 11.285 1.66797 10.6948 1.66797 10.0003C1.66797 9.30588 1.91102 8.7156 2.39714 8.22949C2.88325 7.74338 3.47352 7.50033 4.16797 7.50033C4.5013 7.50033 4.8138 7.55935 5.10547 7.67741C5.39714 7.79546 5.65408 7.95866 5.8763 8.16699L11.7305 4.75033C11.7027 4.6531 11.6853 4.55935 11.6784 4.46908C11.6714 4.3788 11.668 4.2781 11.668 4.16699C11.668 3.47255 11.911 2.88227 12.3971 2.39616C12.8832 1.91005 13.4735 1.66699 14.168 1.66699C14.8624 1.66699 15.4527 1.91005 15.9388 2.39616C16.4249 2.88227 16.668 3.47255 16.668 4.16699C16.668 4.86144 16.4249 5.45171 15.9388 5.93783C15.4527 6.42394 14.8624 6.66699 14.168 6.66699C13.8346 6.66699 13.5221 6.60796 13.2305 6.48991C12.9388 6.37185 12.6819 6.20866 12.4596 6.00033L6.60547 9.41699C6.63325 9.51421 6.65061 9.60796 6.65755 9.69824C6.6645 9.78852 6.66797 9.88921 6.66797 10.0003C6.66797 10.1114 6.6645 10.2121 6.65755 10.3024C6.65061 10.3927 6.63325 10.4864 6.60547 10.5837L12.4596 14.0003C12.6819 13.792 12.9388 13.6288 13.2305 13.5107C13.5221 13.3927 13.8346 13.3337 14.168 13.3337C14.8624 13.3337 15.4527 13.5767 15.9388 14.0628C16.4249 14.5489 16.668 15.1392 16.668 15.8337C16.668 16.5281 16.4249 17.1184 15.9388 17.6045C15.4527 18.0906 14.8624 18.3337 14.168 18.3337Z" fill="#17B26A"/>
</svg>

      </button> -->
  </div>
</div>
<!-- Order invoice end-->
<!-- Payment Recived start -->
<hr
  class="divider"
  *ngIf="showPaymentReceived.includes(orderData?.state?.code)"
/>
<div
  class="section-card"
  *ngIf="showPaymentReceived.includes(orderData?.state?.code)"
>
  <div
    class="section-header mb-3 d-flex align-items-center justify-content-between"
  >
    <h4 class="section-title">Payment Received</h4>
    <!-- <a href="#" class="btn-link btn-link-primary">Edit</a> -->
    <!-- <button class="btn btn-primary" (click)="openAddEstimateModal()">
      Add Estimate
    </button> -->
  </div>
  <div class="order-type-card">
    <div class="order-type-content d-flex align-items-center mb-3">
      <div>
        <h3 class="font-extrabold text-primary-light-950">
          ₹{{ orderData?.totals?.amount }}
        </h3>
        <p class="update-time">
          {{
            this._commonService.getStatusDate(
              this.orderDetails?.historyCompact,
              'Order Paid'
            ) | date : 'HH:mm ddMMM yyyy'
          }}
        </p>
      </div>
    </div>
    <p class="text-body1 text-primary-light-950 font-bold">
      Sort Payment : ₹{{ orderData?.paymentDetail?.amountDiff }}
    </p>
  </div>
  <!-- <button class="btn-link btn-link-primary" (click)="openAddEstimateModal()">
    VIEW FARE DETAILS 
  </button> -->
</div>

<!-- Payment Recived end -->
<div class="sidebar-footer">
  <div class="d-flex align-items-center gap-3 justify-content-between">
    <button
      *ngIf="
        orderData?.state?.code === orderStateCode['admin-pending'] ||
        orderData?.state?.code === orderStateCode['requested'] ||
        orderData?.state?.code === orderStateCode['estimated']
      "
      (click)="onAddPickupClick()"
      class="btn btn-light gap-2 d-flex align-items-center"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16699 10.8337V13.3337C9.16699 13.5698 9.24685 13.7677 9.40658 13.9274C9.5663 14.0871 9.76421 14.167 10.0003 14.167C10.2364 14.167 10.4344 14.0871 10.5941 13.9274C10.7538 13.7677 10.8337 13.5698 10.8337 13.3337V10.8337H13.3337C13.5698 10.8337 13.7677 10.7538 13.9274 10.5941C14.0871 10.4344 14.167 10.2364 14.167 10.0003C14.167 9.76421 14.0871 9.5663 13.9274 9.40658C13.7677 9.24685 13.5698 9.16699 13.3337 9.16699H10.8337V6.66699C10.8337 6.43088 10.7538 6.23296 10.5941 6.07324C10.4344 5.91352 10.2364 5.83366 10.0003 5.83366C9.76421 5.83366 9.5663 5.91352 9.40658 6.07324C9.24685 6.23296 9.16699 6.43088 9.16699 6.66699V9.16699H6.66699C6.43088 9.16699 6.23296 9.24685 6.07324 9.40658C5.91352 9.5663 5.83366 9.76421 5.83366 10.0003C5.83366 10.2364 5.91352 10.4344 6.07324 10.5941C6.23296 10.7538 6.43088 10.8337 6.66699 10.8337H9.16699ZM10.0003 18.3337C8.84755 18.3337 7.76421 18.1149 6.75033 17.6774C5.73644 17.2399 4.85449 16.6462 4.10449 15.8962C3.35449 15.1462 2.76074 14.2642 2.32324 13.2503C1.88574 12.2364 1.66699 11.1531 1.66699 10.0003C1.66699 8.84755 1.88574 7.76421 2.32324 6.75033C2.76074 5.73644 3.35449 4.85449 4.10449 4.10449C4.85449 3.35449 5.73644 2.76074 6.75033 2.32324C7.76421 1.88574 8.84755 1.66699 10.0003 1.66699C11.1531 1.66699 12.2364 1.88574 13.2503 2.32324C14.2642 2.76074 15.1462 3.35449 15.8962 4.10449C16.6462 4.85449 17.2399 5.73644 17.6774 6.75033C18.1149 7.76421 18.3337 8.84755 18.3337 10.0003C18.3337 11.1531 18.1149 12.2364 17.6774 13.2503C17.2399 14.2642 16.6462 15.1462 15.8962 15.8962C15.1462 16.6462 14.2642 17.2399 13.2503 17.6774C12.2364 18.1149 11.1531 18.3337 10.0003 18.3337Z"
          fill="#004B64"
        />
      </svg>
      Pickup
    </button>
    <button
      *ngIf="
        orderData?.subOrders &&
        orderData?.subOrders.length > 0 &&
        orderData?.state?.code === orderStateCode['admin-pending']
      "
      (click)="onCreateOrderClick()"
      class="btn btn-primary gap-2 d-flex align-items-center"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.83366 11.5003L7.04199 9.70866C6.88921 9.55588 6.69477 9.47949 6.45866 9.47949C6.22255 9.47949 6.0281 9.55588 5.87533 9.70866C5.72255 9.86144 5.64616 10.0559 5.64616 10.292C5.64616 10.5281 5.72255 10.7225 5.87533 10.8753L8.25033 13.2503C8.41699 13.417 8.61144 13.5003 8.83366 13.5003C9.05588 13.5003 9.25033 13.417 9.41699 13.2503L14.1253 8.54199C14.2781 8.38921 14.3545 8.19477 14.3545 7.95866C14.3545 7.72255 14.2781 7.5281 14.1253 7.37533C13.9725 7.22255 13.7781 7.14616 13.542 7.14616C13.3059 7.14616 13.1114 7.22255 12.9587 7.37533L8.83366 11.5003ZM10.0003 18.3337C8.84755 18.3337 7.76421 18.1149 6.75033 17.6774C5.73644 17.2399 4.85449 16.6462 4.10449 15.8962C3.35449 15.1462 2.76074 14.2642 2.32324 13.2503C1.88574 12.2364 1.66699 11.1531 1.66699 10.0003C1.66699 8.84755 1.88574 7.76421 2.32324 6.75033C2.76074 5.73644 3.35449 4.85449 4.10449 4.10449C4.85449 3.35449 5.73644 2.76074 6.75033 2.32324C7.76421 1.88574 8.84755 1.66699 10.0003 1.66699C11.1531 1.66699 12.2364 1.88574 13.2503 2.32324C14.2642 2.76074 15.1462 3.35449 15.8962 4.10449C16.6462 4.85449 17.2399 5.73644 17.6774 6.75033C18.1149 7.76421 18.3337 8.84755 18.3337 10.0003C18.3337 11.1531 18.1149 12.2364 17.6774 13.2503C17.2399 14.2642 16.6462 15.1462 15.8962 15.8962C15.1462 16.6462 14.2642 17.2399 13.2503 17.6774C12.2364 18.1149 11.1531 18.3337 10.0003 18.3337Z"
          fill="white"
        />
      </svg>
      CREATE
    </button>
  </div>
</div>
